export const TABLE_HEADERS = [
  { id: "name", label: "NAME", flex: 2 },
  { id: "quantity", label: "QTY", flex: 2 },
  { id: "price", label: "PRICE", flex: 1 },
];

export type TQUEST = {
  id: number;
  title: string;
  points: number;
  quantity: number;
};
